export enum UserPlan {
  Free = "free",
  Basic = "basic",
  Standard = "standard",
  Premium = "premium"
}

export const UserPlans = [
  UserPlan.Premium,
  UserPlan.Standard,
  UserPlan.Basic,
  UserPlan.Free
];
